class Lollipop {
  constructor() {
    this.petalSize = 0;
    this.pathoIndex = null;
    this.region = null;
    this.containedCodingImpacts = new Set();
    this.containedDbs = new Set();
    this.petals = [];
  }

  addPetal(petal) {
    this.petals.push(petal);
    this.petalSize += 1;
  }

  containsAnyImpact(impacts) {
    return (
      impacts.find((x) => this.containedCodingImpacts.has(x)) !== undefined
    );
  }

  containsAnyDb(dbs) {
    return dbs.find((x) => this.containedDbs.has(x));
  }

  contains(impactArr, impactSet, dbs) {
    if (impactSet.size === 0 && dbs.length === 0) return true;
    if (impactSet.size === 0) return this.containsAnyDb(dbs);
    if (dbs.length === 0) return this.containsAnyImpact(impactArr);

    for (let i = 0; i < this.petals.length; i++) {
      const hasImp = impactSet.has(this.petals[i].codingImpactIndex);
      const hasDb = this.petals[i].hasAnyDb(dbs);
      if (hasImp && hasDb) return true;
    }

    return false;
  }

  addVariant(pathogenicityDetails) {
    this.region = pathogenicityDetails.variant.region;
    this.pathoIndex = pathogenicityDetails.pathoIndex;
    const { codingImpactIndex: ci, sourceIndex: si } = pathogenicityDetails;

    this.containedCodingImpacts.add(ci);
    this.containedDbs.add(si);
  }
}

export default Lollipop;
